import React, { memo, useState } from 'react';
import { Table, TableFooter, WithTableLayout } from '@qrios/frontend-library';
import endpoints from '../../../../../../api/endpoints';
import { mapApiDataIntoTableFormat } from './dataTransformator';
import { columns } from './columns';
import { ActiveUserItem, ActiveUsersResponse, UserDetailsProp } from './interfaces';
import { Dialog } from '../../../../../common/dialog';
import UserDetails from './user-details';
import locales from './locales';
import { useUserRoleUpdate } from './user-details/hooks/useUserRoleUpdate';
import { useFetch } from '../../../../../../api/useFetch';
import TableFooterInfo from '../../../../../common/table/footerInfo';
import { UserRoleItem } from '../interfaces';

const ActiveUserTable = () => {
  const { data = {} as ActiveUsersResponse, refresh, loading, error, previousOptions } = useFetch<ActiveUsersResponse>({
    pathname: endpoints.accountsManagementActive
  });

  const [selectedUser, setSelectedUser] = useState<UserDetailsProp | undefined>();
  const {
    updateError,
    updateLoading,
    userUpdateModalOpen,
    handleCloseUserRoleUpdate,
    handleOpenUserRoleUpdate,
    handleUserRoleUpdate
  } = useUserRoleUpdate({
    handleSuccess: () => {
      refresh();
    }
  });

  const handleOpenDetails = (userData: ActiveUserItem, roles: UserRoleItem[]) => {
    const use: UserDetailsProp = { userData, roles };
    setSelectedUser(use);
    handleOpenUserRoleUpdate();
  };

  const tableRowActions = {
    openDetails: handleOpenDetails
  };

  const handleCloseAction = async () => {
    handleCloseUserRoleUpdate();
  };

  return (
    <>
      <WithTableLayout>
        <Table
          dataGridProps={{
            rows: !data?.users || loading ? [] : mapApiDataIntoTableFormat(data, tableRowActions),
            columns,
            loading,
            error: {
              message: error,
              refresh: () => refresh(previousOptions)
            }
          }}
        />
        {!error && (
          <TableFooter
            tableInfo={<TableFooterInfo label="Active users" tooltip="" value="" />}
            refreshProps={{ disabled: loading, handler: refresh }}
          />
        )}
      </WithTableLayout>
      <Dialog open={userUpdateModalOpen} handleClose={handleCloseAction} title={locales.dialog.details.title}>
        {selectedUser && (
          <UserDetails
            selectedUser={selectedUser}
            handleCloseDialog={handleCloseAction}
            onSubmit={handleUserRoleUpdate}
            loading={updateLoading}
            error={updateError}
          />
        )}
      </Dialog>
    </>
  );
};

export default memo(ActiveUserTable);
